import axios from 'axios'

const ApprovalService = {
  async get (params = {}) {
    return axios.get('rm/inter-branch-transfer/request-approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('rm/reports/inter-branch-transfer/approval-histories', { params })
  },

  async show (id) {
    return axios.get(`rm/inter-branch-transfer/request-approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('rm/inter-branch-transfer/request-approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rm/inter-branch-transfer/request-approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rm/inter-branch-transfer/request-approvals/${data.id}`, { data })
  }
}

export default ApprovalService
